export const SET_BATCH_DATA = "SET_BATCH_DATA";
export const SET_WALLET_STACKING_M_DATA = "SET_WALLET_STACKING_M_DATA";
export const SET_WALLET_STACKING_O_DATA = "SET_WALLET_STACKING_O_DATA";
export const SET_WALLET_STACKING_R_DATA = "SET_WALLET_STACKING_R_DATA";
export const SET_STACKING_SELECTED_ZONE = "SET_STACKING_SELECTED_ZONE";
export const RESET_BATCH_REDUCER = "RESET_BATCH_REDUCER";
